import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Pane, TabNavigation, Tab, Button, Position, Menu, Popover } from 'evergreen-ui';
import { useAuth } from '../context/AuthContext';

function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuth();

  const navItems = [
    { name: 'Dashboard', path: '/dashboard' },
    { name: 'Graph', path: '/graph' },
    { name: 'Workers', path: '/workers' },
    { name: 'Notes', path: '/notes' },
    { name: 'Projects', path: '/projects' },
    { name: 'Results', path: '/results' },
    { name: 'Scope', path: '/scope' },
    { name: 'Report', path: '/report' },
    { name: 'Tasks', path: '/tasks' },
    { name: 'Coverage', path: '/coverage' },
    { name: 'Members', path: '/members' },
    { name: 'Upload', path: '/upload' },
    { name: 'Create Finding', path: '/create-finding' },
  ];

  return (
    <Pane 
      elevation={1} 
      backgroundColor="white" 
      padding={16}
      position="fixed"
      top={0}
      width="100%"
      zIndex={1}
      display="flex"
      alignItems="center"
      borderBottom="1px solid"
      borderColor="border.default"
    >
      <TabNavigation>
        {navItems.map(({ name, path }) => (
          <Tab
            key={path}
            id={path}
            isSelected={location.pathname === path}
            onSelect={() => navigate(path)}
            aria-current={location.pathname === path}
          >
            {name}
          </Tab>
        ))}
      </TabNavigation>

      <Pane marginLeft="auto" display="flex" alignItems="center" gap={8}>
        <Popover
          position={Position.BOTTOM_RIGHT}
          content={
            <Menu>
              <Menu.Group>
                <Menu.Item onSelect={() => navigate('/profile')}>
                  Profile Settings
                </Menu.Item>
              </Menu.Group>
              <Menu.Divider />
              <Menu.Group>
                <Menu.Item intent="danger" onSelect={logout}>
                  Logout
                </Menu.Item>
              </Menu.Group>
            </Menu>
          }
        >
          <Button>Account</Button>
        </Popover>
      </Pane>
    </Pane>
  );
}

export default Navbar; 